export default __webpack_public_path__ + "static/leadership-fr-49766d770b294f0b04ce1e1aa7a1fd0b.webp";